// ClipRadar — the multilingual marquee: greetings drift past like the languages
// in a working library, edge-masked, a few carrying more light (founder ref:
// Jumper's moving strip — ours is dawn-tiered, one warm word). True fact:
// ClipRadar transcribes and searches 110+ languages. Motion is a slow linear
// track (crw-lang-* in site.css); reduced-motion holds it still.
import type { CSSProperties } from 'react';
import { MonoNote } from '../components/primitives';

// [word, tier, language] — 0 ghost · 1 mid · 2 bright · 3 the one warm word;
// the language name is the hover reveal (delight: the strip pauses under the
// cursor and the word introduces itself — product-true, all searchable)
const GREETINGS: [string, 0 | 1 | 2 | 3, string][] = [
  ['Hola', 1, 'Spanish'], ['Hallo', 0, 'German'], ['مرحبا', 3, 'Arabic'], ['Ciao', 0, 'Italian'], ['नमस्ते', 1, 'Hindi'], ['こんにちは', 0, 'Japanese'],
  ['你好', 2, 'Mandarin'], ['Bonjour', 0, 'French'], ['Olá', 0, 'Portuguese'], ['Merhaba', 1, 'Turkish'], ['Xin chào', 0, 'Vietnamese'], ['שלום', 2, 'Hebrew'],
  ['안녕하세요', 0, 'Korean'], ['Γεια σου', 1, 'Greek'], ['Привіт', 0, 'Ukrainian'], ['Salut', 0, 'Romanian'], ['Hej', 1, 'Swedish'], ['Ahoj', 0, 'Czech'],
];
const TIER_COLOR = ['var(--fg-4)', 'var(--fg-3)', 'var(--fg-2)', 'var(--signal-300)'];

function Row() {
  return (
    <div className="crw-langrow" aria-hidden="true">
      {GREETINGS.map(([w, tier, lang], i) => (
        <span key={`${w}-${i}`} className="crw-langword" data-lang={lang} style={{ '--lw': TIER_COLOR[tier] } as CSSProperties}>{w}</span>
      ))}
    </div>
  );
}

export function MultilingualStrip() {
  return (
    <section aria-label="Languages ClipRadar understands" style={{ padding: '58px 0 54px', overflow: 'hidden' }}>
      <div className="crw-langmask">
        {/* two copies back-to-back — the track translates -50% and loops seamlessly */}
        <div className="crw-langtrack">
          <Row />
          <Row />
        </div>
      </div>
      <div style={{ marginTop: 22, display: 'flex', justifyContent: 'center', padding: '0 24px' }}>
        <MonoNote style={{ letterSpacing: '0.1em', textAlign: 'center' }}>110+ languages · transcribed and searched on your machine</MonoNote>
      </div>
    </section>
  );
}
